<template>
  <div class="d-flex justify-content-center align-items-center body-content" style="min-height: 75vh;">
    <div class="text-center" style="max-width: 500px; width: 100%;">
      <p class="font-18 mb-4 font-weight-bold">
        認証が完了しました！
      </p>
      <p class="font-16 mb-4 font-weight-bold">
        Bloomキャリア登録を利用する<br />
        大手企業各社へ追加登録が可能です
      </p>
      <button
        class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
        @click="handleOkClick"
        :style="buttonStyle"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationPage',
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({
        background: 'red',
        'border-color': 'red'
      })
    }
  },
  methods: {
    handleOkClick() {
      this.$emit('ok-clicked');
    }
  }
};
</script>

<style scoped>
.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 3px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #006C6B !important;
  border-color: #006C6B !important;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}
</style> 